<template>
    <div class="pt15">
        <div class="sub_title">
           입금정보
        </div>
        <div class="c_table_wrap">
            <table>
                <colgroup>
                    <col width="200px;">
                    <col width="">
                    <col width="200px;">
                    <col width="">
                </colgroup>
                <tbody>
                <tr>
                    <td class="c_t_title">입금자</td>
                    <td colspan="3">
                        <div class="d_block">
                            {{ orderData.depositName }}
                        </div>
                    </td>
                </tr>

                <tr>
                    <td class="c_t_title">입금은행</td>
                    <td>
                        <div class="d_block">
                            {{ orderData.bankName }}
                        </div>
                    </td>
                    <td class="c_t_title">입금액</td>
                    <td>
                        <div class="d_block">
                            ￦{{ returnCommas(orderData.price) }}
                        </div>
                    </td>
                </tr>

                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import numberMixins from "@/mixins/NumberMixins";
export default {
    name: "DepositInformationLayout",
    mixins: [numberMixins],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {
        orderData: {
            default: () => {
            }, type: Object
        },
    },
    data() {
        return {
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
